// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13NNG","footer":"styles_footer__cHx72","passCodeTooltip":"styles_passCodeTooltip__zIAMb"};